import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW_GLOBAL_OBJECT', {
  providedIn: 'root',
  factory: () => window
});
